/**
 * Editorial / marketing imagery from `src/assets/` (full-size photos).
 * The `marketing/` subfolder may contain tiny build stubs — use root assets for real JPGs.
 */
import heroMain from '../assets/hero-main.jpg';
import catWomen from '../assets/category-women.jpg';
import catMen from '../assets/category-men.jpg';
import catLounge from '../assets/editorial-1.jpg';
import catResort from '../assets/hero-men.jpg';
import catAccessories from '../assets/look-4.jpg';
import look1 from '../assets/look-1.jpg';
import look2 from '../assets/look-2.jpg';
import look3 from '../assets/look-3.jpg';
import ig1 from '../assets/look-1.jpg';
import ig2 from '../assets/look-2.jpg';
import ig3 from '../assets/look-3.jpg';
import ig4 from '../assets/look-4.jpg';
import ig5 from '../assets/hero-women.jpg';
import ig6 from '../assets/editorial-1.jpg';

export const siteImagery = {
  heroMain,
  catWomen,
  catMen,
  catLounge,
  catResort,
  catAccessories,
  look1,
  look2,
  look3,
  ig1,
  ig2,
  ig3,
  ig4,
  ig5,
  ig6,
};
